<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { computed } from 'vue';
import FieldDescription from './internal/FieldDescription.vue';
import FieldGroup from './internal/FieldGroup.vue';
import FieldLegend from './internal/FieldLegend.vue';
import FieldSet from './internal/FieldSet.vue';

defineOptions({
    compatConfig: { MODE: 3 },
});

const props = defineProps<{
    title?: string
    description?: string
    class?: HTMLAttributes['class']
}>();

const hasSemantic = computed(() => !!(props.title || props.description));
</script>

<template>
    <FieldSet
        v-if="hasSemantic"
    >
        <FieldLegend
            v-if="props.title"
            variant="legend"
        >
            {{ props.title }}
        </FieldLegend>

        <FieldDescription v-if="props.description">
            {{ props.description }}
        </FieldDescription>

        <FieldGroup
            :class="props.class"
        >
            <slot></slot>
        </FieldGroup>
    </FieldSet>
    <FieldGroup
        v-else
        :class="props.class"
    >
        <slot></slot>
    </FieldGroup>
</template>
